import { useAuth } from '../context/AuthContext';
import { hasScreenPermission } from '../lib/permissions';

export interface ScreenPermissions {
  canView: boolean;
  canEdit: boolean;
  canCreate: boolean;
  canDelete: boolean;
  canExport: boolean;
  canImport: boolean;
}

/**
 * Per-action permission gate for a given screen — built on the existing
 * hasScreenPermission (client/src/lib/permissions.ts), which until now was only
 * ever used for nav filtering (Sidebar) and whole-route gating (PermissionRoute).
 * Use this inside page components to hide/disable individual Edit/Create/Delete/
 * Export/Import controls instead of duplicating ad-hoc permission conditionals.
 */
export function usePermission(screen: string): ScreenPermissions {
  const { user } = useAuth();
  return {
    canView: hasScreenPermission(user, screen, 'view'),
    canEdit: hasScreenPermission(user, screen, 'edit'),
    canCreate: hasScreenPermission(user, screen, 'create'),
    canDelete: hasScreenPermission(user, screen, 'delete'),
    canExport: hasScreenPermission(user, screen, 'export'),
    canImport: hasScreenPermission(user, screen, 'import'),
  };
}
